module.exports = __webpack_public_path__ + "img/police.1cee079c.png";